module.exports = __webpack_public_path__ + "img/_3.668fb06a.png";